import { isFeatureEnabled } from "../../../services/FeatureFlagService";

export const PDM_SUPPORT_ASSURANCE_FLAG =
  "Forms.PDMSupportAssurance.Enabled";
export const LEGACY_COSELL_FORM_KEY = "Co";
export const PDM_SUPPORT_ASSURANCE_FORM_KEY = "PdmSa";
export const LEGACY_COSELL_TITLE = "Co-Sell";
export const PDM_SUPPORT_ASSURANCE_TITLE = "PDM Support Assurance";

interface FormContext {
  name?: string;
  tileName?: string;
  serviceWithFormKey?: string;
  [key: string]: unknown;
}

const isManagedTile = (value?: string) =>
  value === LEGACY_COSELL_TITLE || value === PDM_SUPPORT_ASSURANCE_TITLE;

export const isPdmSupportAssuranceEnabled = (): boolean =>
  isFeatureEnabled(PDM_SUPPORT_ASSURANCE_FLAG);

export const resolvePdmSupportAssuranceTitle = (title?: string): string => {
  if (!isManagedTile(title)) {
    return title || "";
  }

  return isPdmSupportAssuranceEnabled()
    ? PDM_SUPPORT_ASSURANCE_TITLE
    : LEGACY_COSELL_TITLE;
};

export const resolvePdmSupportAssuranceLookupTitle = (
  title?: string
): string => (isManagedTile(title) ? LEGACY_COSELL_TITLE : title || "");

export const resolvePdmSupportAssuranceContext = <T extends FormContext>(
  context: T
): T => {
  const isManagedContext =
    context.serviceWithFormKey === LEGACY_COSELL_FORM_KEY ||
    context.serviceWithFormKey === PDM_SUPPORT_ASSURANCE_FORM_KEY ||
    isManagedTile(context.name) ||
    isManagedTile(context.tileName);

  if (!isManagedContext) {
    return context;
  }

  const enabled = isPdmSupportAssuranceEnabled();
  return {
    ...context,
    name: enabled ? PDM_SUPPORT_ASSURANCE_TITLE : LEGACY_COSELL_TITLE,
    serviceWithFormKey: enabled
      ? PDM_SUPPORT_ASSURANCE_FORM_KEY
      : LEGACY_COSELL_FORM_KEY,
  };
};

// Generated by Copilot
// updated on: 2026-08-18 | 59 lines added | [Auto Generated] | Added fail-safe title, form-context, and P-URL lookup resolution for legacy and PDM paths | Time Taken 20 min
